import React from "react";
import { OverlayTrigger, Popover } from 'react-bootstrap';

function CustomPopover(props) {
    const myPopover = (
        <Popover id="popover-basic" className={`customize-tooltip`}>
            <Popover.Content>
                {props.tooltip}
            </Popover.Content>
        </Popover>
    )
    return (
        <>
            <OverlayTrigger
                trigger={props.click ? 'click' : ['hover', 'focus']}
                placement={props.placement}
                overlay={myPopover}
            >
                <span>{props.children}</span>
            </OverlayTrigger>
        </>
    );
}



export default CustomPopover;